module.exports = __webpack_public_path__ + "img/edit.9cd93fbe.svg";